import { useEffect, useState } from "react";
import { useParams, NavLink, Outlet } from "react-router-dom";
import { adminInstituicoesApi } from "../../../api/adminInstituicoes";
import "./AdminInstituicaoDetalhe.scss";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export default function AdminInstituicaoDetalhe() {
  const { id } = useParams();
  const [inst, setInst] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminInstituicoesApi
      .obter(id)
      .then(setInst)
      .catch(() => setInst(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p style={{ padding: "1.5rem" }}>Carregando...</p>;
  if (!inst)
    return <p style={{ padding: "1.5rem" }}>Instituição não encontrada.</p>;

  const iniciais = String(inst.sigla || inst.nome || "?")
    .slice(0, 3)
    .toUpperCase();

  return (
    <div className="admin-inst-detalhe">
      <header>
        {inst.logoUrl ? (
          <img src={`${API_BASE}${inst.logoUrl}`} alt={`Logo ${inst.nome}`} />
        ) : (
          <div className="placeholder-logo" aria-hidden="true">
            {iniciais}
          </div>
        )}
        <div className="info">
          <h1>{inst.nome}</h1>
          <span className="sigla">{inst.sigla}</span>
        </div>
      </header>

      <nav className="tabs">
        <NavLink
          to={`/admin/instituicoes/${id}/usuarios`}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Usuários
        </NavLink>
        <NavLink
          to={`/admin/instituicoes/${id}/turmas`}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Turmas
        </NavLink>
        <NavLink
          to={`/admin/instituicoes/${id}/coordenacoes`}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Coordenações
        </NavLink>
      </nav>

      <Outlet />
    </div>
  );
}
